import { inheritsLoose as _inheritsLoose, asyncToGenerator as _asyncToGenerator, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import _regeneratorRuntime from './node_modules/regenerator-runtime/runtime.esm.js';
import { handleSettled } from './utils/handleSettled.esm.js';
import { BaseError } from './utils/error.esm.js';
import { parseNFT } from './utils/parseNFT.esm.js';
import { getImageURI } from './utils/getImageURI.esm.js';
import { createCacheAdapter, fetch } from './utils/fetch.esm.js';
import { isImageURI } from './utils/isImageURI.esm.js';
import * as index from './utils/index.esm.js';
export { index as utils };
import ERC1155 from './specs/erc1155.esm.js';
import ERC721 from './specs/erc721.esm.js';
import URI from './specs/uri.esm.js';

var specs = /*#__PURE__*/Object.freeze({
  erc721: ERC721,
  erc1155: ERC1155
});
var UnsupportedNamespace = /*#__PURE__*/function (_BaseError) {
  _inheritsLoose(UnsupportedNamespace, _BaseError);

  function UnsupportedNamespace() {
    return _BaseError.apply(this, arguments) || this;
  }

  return UnsupportedNamespace;
}(BaseError);
var AvatarResolver = /*#__PURE__*/function () {
  function AvatarResolver(provider, options) {
    this.provider = provider;
    this.options = options;

    if (options != null && options.cache && (options == null ? void 0 : options.cache) > 0) {
      createCacheAdapter(fetch, options == null ? void 0 : options.cache);
    }
  }

  var _proto = AvatarResolver.prototype;

  _proto.getMetadata = /*#__PURE__*/function () {
    var _getMetadata = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ens) {
      var _yield$handleSettled, resolvedAddress, resolver, avatarURI, uriSpec, _metadata, _parseNFT, chainID, namespace, contractAddress, tokenID, Spec, spec, host_meta, metadata;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return handleSettled([this.provider.resolveName(ens), this.provider.getResolver(ens)]);

            case 2:
              _yield$handleSettled = _context.sent;
              resolvedAddress = _yield$handleSettled[0];
              resolver = _yield$handleSettled[1];

              if (resolver) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", null);

            case 7:
              _context.next = 9;
              return resolver.getText('avatar');

            case 9:
              avatarURI = _context.sent;

              if (avatarURI) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", null);

            case 12:
              if (/eip155:/i.test(avatarURI)) {
                _context.next = 18;
                break;
              }

              uriSpec = new URI();
              _context.next = 16;
              return uriSpec.getMetadata(avatarURI, this.options);

            case 16:
              _metadata = _context.sent;
              return _context.abrupt("return", _extends({
                uri: ens
              }, _metadata));

            case 18:
              // parse retrieved avatar uri
              _parseNFT = parseNFT(avatarURI), chainID = _parseNFT.chainID, namespace = _parseNFT.namespace, contractAddress = _parseNFT.contractAddress, tokenID = _parseNFT.tokenID; // detect avatar spec by namespace

              Spec = specs[namespace];

              if (Spec) {
                _context.next = 22;
                break;
              }

              throw new UnsupportedNamespace("Unsupported namespace: " + namespace);

            case 22:
              spec = new Spec(); // add meta information of the avatar record

              host_meta = {
                chain_id: chainID,
                namespace: namespace,
                contract_address: contractAddress,
                token_id: tokenID,
                reference_url: "https://opensea.io/assets/" + contractAddress + "/" + tokenID
              }; // retrieve metadata

              _context.next = 26;
              return spec.getMetadata(this.provider, resolvedAddress, contractAddress, tokenID, this.options);

            case 26:
              metadata = _context.sent;
              return _context.abrupt("return", _extends({
                uri: ens,
                host_meta: host_meta
              }, metadata));

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getMetadata(_x) {
      return _getMetadata.apply(this, arguments);
    }

    return getMetadata;
  }();

  _proto.getAvatar = /*#__PURE__*/function () {
    var _getAvatar = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ens, data) {
      var _this$options, _this$options2, _this$options3;

      var metadata, imageURI, isImage;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getMetadata(ens);

            case 2:
              metadata = _context2.sent;

              if (metadata) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", null);

            case 5:
              imageURI = getImageURI({
                metadata: metadata,
                gateways: {
                  ipfs: (_this$options = this.options) == null ? void 0 : _this$options.ipfs,
                  arweave: (_this$options2 = this.options) == null ? void 0 : _this$options2.arweave
                },
                jsdomWindow: data == null ? void 0 : data.jsdomWindow,
                urlDenyList: (_this$options3 = this.options) == null ? void 0 : _this$options3.urlDenyList
              });

              if (!( // do check only NFTs since raw uri has this check built-in
              metadata.hasOwnProperty('host_meta') && imageURI != null && imageURI.startsWith('http'))) {
                _context2.next = 11;
                break;
              }

              _context2.next = 9;
              return isImageURI(imageURI);

            case 9:
              isImage = _context2.sent;
              return _context2.abrupt("return", isImage ? imageURI : null);

            case 11:
              return _context2.abrupt("return", imageURI);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getAvatar(_x2, _x3) {
      return _getAvatar.apply(this, arguments);
    }

    return getAvatar;
  }();

  return AvatarResolver;
}();

export { AvatarResolver, UnsupportedNamespace, specs };
//# sourceMappingURL=index.esm.js.map
